import { WebPaymentDto } from '@up/data';

export class FireOpenWebPaymentResponse {
  message?: string;
  success: boolean;
  payment?: WebPaymentDto;
  code?: string;
}
